import { EntityBatchNode, type EntityBatchNodeProps } from "./EntityBatchNode";

export function ContactRecordBatchNode(props: Omit<EntityBatchNodeProps, "fallbackLabel">) {
  return <EntityBatchNode {...props} fallbackLabel="Contact Record Batch" />;
}
